import { ReactElement } from "react";
import styled from "styled-components";

import { BaseProposal } from "./BaseProposal";

type Props = {
    // Inactive, but kept focusable (aria-disabled rather than disabled) so
    // keyboard focus is not lost when the button becomes inactive (RGAA 12.8)
    isDisabled: boolean;
    color: string;
    text: ReactElement;
    onClick: () => void;
};

const ValidateButton = ({ isDisabled, color, text, onClick }: Props) => {
    function handleClick() {
        if (isDisabled) {
            return;
        }
        onClick();
    }

    return (
        <StyledButton
            data-testid="quiz-validate-button"
            aria-disabled={isDisabled || undefined}
            onClick={handleClick}
            color={color}
        >
            <>{text}</>
        </StyledButton>
    );
};

const StyledButton = styled(BaseProposal)`
    color: #fff;
    background-color: ${(props) => props.color};
    border: 1px solid ${(props) => props.color};
    margin-bottom: 0;
    min-height: 2.5rem;
    border-radius: 4px;
    &[aria-disabled="true"] {
        opacity: 0.65;
        cursor: not-allowed;
    }
`;

export default ValidateButton;
